import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ReportPage } from '@/features/reports/reports-pages';

const day = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .optional()
  .catch(undefined);
const searchSchema = z.object({ start: day, end: day });

export const Route = createFileRoute('/_app/projects/$projectId/reports/$reportKey')({
  validateSearch: searchSchema,
  component: ReportRoute,
});

function ReportRoute() {
  const { projectId, reportKey } = Route.useParams();
  const range = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ReportPage
      scope={{ kind: 'project', id: projectId }}
      reportKey={reportKey}
      range={range}
      onRange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
